<template lang="pug">
.student-list(:data-role='userRole')
  //- サイドメニュー部
  side-menu.student-list__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .student-list__content
    breadcrumb-list.student-list__content__breadcrumb(
      v-if='isAdmin',
      :breadcrumbs='breadcrumbs',
      :buttonEvent='openRegisterModal'
    )
      template(#buttonLabel)
        slot(name='breadcrumbButtonLabel')
    breadcrumb-list.student-list__content__breadcrumb(v-else, :breadcrumbs='breadcrumbs')
    .student-list__content__body
      .student-list__content__body__heading
        tab-heading.student-list__content__body__heading__tab(
          v-if='!isBranch',
          :isActive='false',
          @click='tabHeadingEvent(tabSetting.TEACHER.value)'
        ) {{ tabSetting.TEACHER.text }}
        tab-heading.student-list__content__body__heading__tab(:isActive='true') {{ tabSetting.STUDENT.text }}
      .student-list__content__body__main
        .student-list__content__body__main__action
          search-student.student-list__content__body__main__action__search(
            :userRole='userRole',
            :gradeSelectOptions='gradeSelectOptions',
            :gradeValue='gradeValue',
            :fullName='fullName',
            :academyName='academyName',
            :branchName='branchName',
            :status='status',
            :fullNamePlaceholder='fullNamePlaceholder',
            :academyNamePlaceholder='academyNamePlaceholder',
            :branchNamePlaceholder='branchNamePlaceholder',
            :statusPlaceholder='statusPlaceholder',
            :gradeChangeEvent='setGradeValue',
            :fullNameChangeEvent='setFullName',
            :academyNameChangeEvent='setAcademyName',
            :branchNameChangeEvent='setBranchName',
            :statusChangeEvent='setStatus',
            :searchEvent='searchEvent'
          )
            template(#searchButtonText)
              slot(name='searchButtonText')
          .student-list__content__body__main__action__button
            button-icon-circle.student-list__content__body__main__action__button__icon(
              type='qr',
              @click='qrOutputEvent'
            )
              slot(name='qrOutputIconLabel')
            button-icon-circle.student-list__content__body__main__action__button__icon(
              type='download',
              @click='downloadEvent'
            )
              slot(name='downloadIconLabel')
            button-upload.student-list__content__body__main__action__button__icon(
              v-if='isAdmin',
              :uploadEvent='uploadEvent'
            )
              template(#iconLabel)
                slot(name='uploadIconLabel')
        student-list-table.student-list__content__body__main__table(
          v-if='sort && studentDatas',
          :userRole='userRole',
          :checkedAll='checkedAll',
          :headerCheckboxChangeEvent='setCheckedAll',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :studentDatas='studentDatas',
          :checkedStudentUserIds='checkedStudentUserIds',
          :checkboxChangeEvent='setCheckedStudentUserIds',
          :deleteEvent='deleteEvent',
          :editEvent='openEditModal'
        )
          template(#userNameHeader)
            slot(name='userNameHeader')
          template(#bcbtCodeHeader)
            slot(name='bcbtCodeHeader')
          template(#academyNameHeader)
            slot(name='academyNameHeader')
          template(#branchNameHeader)
            slot(name='branchNameHeader')
          template(#gradeNameHeader)
            slot(name='gradeNameHeader')
          template(#statusNameHeader)
            slot(name='statusNameHeader')
          template(#editHeader)
            slot(name='editHeader')
          template(#popupRemoveText)
            slot(name='popupRemoveText')
          template(#popupEditText)
            slot(name='popupEditText')
        .student-list__content__body__main__footer
          button-pagination.student-list__content__body__main__footer__pager(
            :status='pagenationStatus',
            @click='pagenationEvent'
          )
  //- モーダル部
  modal-student-edit.student-list__modal(
    v-if='studentEditData',
    ref='modalStudentEdit',
    :userRole='userRole',
    :title='modalTitle',
    :userNamePlaceholder='modalUserNamePlaceholder',
    :userBcbtCodePlaceholder='modalUserBcbtCodePlaceholder',
    :passwordPlaceholder='modalPasswordPlaceholder',
    :passwordConfirmPlaceholder='modalPasswordConfirmPlaceholder',
    :statusPlaceholder='modalStatusPlaceholder',
    :studentEditData='studentEditData',
    :academySelectOptions='modalAcademySelectOptions',
    :academyChangeEvent='modalAcademyChangeEvent',
    :branchSelectOptions='modalBranchSelectOptions',
    :gradeSelectOptions='modalGradeSelectOptions',
    :keepButtonEvent='modalKeepButtonEvent',
    :errorMessages='modalErrorMessages'
  )
    template(#academyNameLabel)
      slot(name='modalAcademyNameLabel')
    template(#academyNameDisabledLabel)
      slot(name='modalAcademyNameDisabledLabel')
    template(#branchNameLabel)
      slot(name='modalBranchNameLabel')
    template(#branchNameDisabledLabel)
      slot(name='modalBranchNameDisabledLabel')
    template(#gradeNameLabel)
      slot(name='modalGradeNameLabel')
    template(#userNameLabel)
      slot(name='modalUserNameLabel')
    template(#userBcbtCodeLabel)
      slot(name='modalUserBcbtCodeLabel')
    template(#passwordLabel)
      slot(name='modalPasswordLabel')
    template(#passwordLabelAnnotation)
      slot(name='modalPasswordLabelAnnotation')
    template(#passwordConfirmLabel)
      slot(name='modalPasswordConfirmLabel')
    template(#passwordConfirmLabelAnnotation)
      slot(name='modalPasswordConfirmLabelAnnotation')
    template(#statusLabel)
      slot(name='modalStatusLabel')
    template(#keepText)
      slot(name='modalKeepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import SearchStudent from '@/components/organisms/manager/SearchStudent.vue'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'
import ButtonUpload from '@/components/molecules/manager/ButtonUpload.vue'
import StudentListTable from '@/components/organisms/manager/StudentListTable.vue'
import ButtonPagination from '@/components/molecules/manager/ButtonPagination.vue'
import ModalStudentEdit from '@/components/organisms/manager/ModalStudentEdit.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudentListType, StudentListSortType, StudentEditType } from '@/models/studentListModel'
import { InputItem } from '@/models/inputItem'
import { PaginationStatus } from '@/models/paginationModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { TeacherStudentTabSetting } from '@/const/TabLinkSettings'
import { SortSetting } from '@/const/SortSettings'

@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    SearchStudent,
    ButtonIconCircle,
    ButtonUpload,
    StudentListTable,
    ButtonPagination,
    ModalStudentEdit,
  },
})
export default class StudentList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // 新規登録用の情報設定イベント（システム管理者画面のみ）
  @Prop()
  setRegisterDataEvent?: Function

  // 見出しタブクリック時のイベント（教室長画面以外）
  @Prop()
  tabHeadingEvent?: Function

  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // 塾名プレースホルダー（ユーザ権限がシステム管理者の場合のみ設定）
  @Prop()
  academyNamePlaceholder?: string

  // 教室名プレースホルダー(ユーザ権限がシステム管理者、塾管理者の場合のみ設定)
  @Prop()
  branchNamePlaceholder?: string

  // ステータスプレースホルダー
  @Prop()
  statusPlaceholder!: string

  // 検索イベント
  @Prop()
  searchEvent!: Function

  // QR出力ボタン押下時イベント
  @Prop()
  qrOutputEvent!: Function

  // ダウンロードボタン押下時イベント
  @Prop()
  downloadEvent!: Function

  // アップロードボタン押下時イベント（システム管理者画面のみ）
  @Prop()
  uploadEvent?: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudentListSortType

  // 生徒一覧情報
  @Prop()
  studentDatas!: StudentListType[]

  // 削除ボタン押下時イベント（システム管理者画面のみ）
  @Prop()
  deleteEvent?: Function

  // 編集用の情報設定イベント
  @Prop()
  setEditDataEvent!: Function

  // ページネーションの状態
  @Prop()
  pagenationStatus!: PaginationStatus

  // ページネーションイベント
  @Prop()
  pagenationEvent!: Function

  // モーダルのタイトル
  @Prop()
  modalTitle!: string

  // モーダルの氏名プレースホルダー（システム管理者画面のみ）
  @Prop()
  modalUserNamePlaceholder?: string

  // モーダルのBCBTコードプレースホルダー（システム管理者画面のみ）
  @Prop()
  modalUserBcbtCodePlaceholder?: string

  // モーダルのパスワードプレースホルダー
  @Prop()
  modalPasswordPlaceholder!: string

  // モーダルのパスワード（確認）プレースホルダー
  @Prop()
  modalPasswordConfirmPlaceholder!: string

  // モーダルのステータスプレースホルダー（システム管理者画面のみ）
  @Prop()
  modalStatusPlaceholder?: string

  // 編集対象のユーザー（生徒）情報
  @Prop()
  studentEditData!: StudentEditType

  // モーダルの塾名選択プルダウンのオプション（システム管理者画面のみ）
  @Prop()
  modalAcademySelectOptions?: InputItem[]

  // モーダルの塾名変更時イベント（システム管理者のみ）
  @Prop()
  modalAcademyChangeEvent?: Function

  // モーダルの教室名選択プルダウンのオプション（システム管理者、塾管理者画面のみ）
  @Prop()
  modalBranchSelectOptions?: InputItem[]

  // モーダルの学年選択プルダウンのオプション
  @Prop()
  modalGradeSelectOptions!: InputItem[]

  // モーダルの保存ボタン押下時イベント
  @Prop()
  modalKeepButtonEvent!: Function

  // モーダルに表示するエラーメッセージ
  @Prop()
  modalErrorMessages!: string[]

  // モーダルref
  @Ref()
  modalStudentEdit!: ModalStudentEdit

  // === 選択値を保持する変数群
  // 学年
  public gradeValue = ''
  // 氏名
  public fullName = ''
  // 塾名
  public academyName = ''
  // 教室名
  public branchName = ''
  // ステータス
  public status = ''
  // 全チェックフラグ
  public checkedAll = false
  // チェックされた生徒ユーザーID
  public checkedStudentUserIds: number[] = []

  // === 選択値をセットする関数群
  // 学年をセット
  private setGradeValue(value: string) {
    this.gradeValue = value
  }
  // 氏名をセット
  private setFullName(value: string) {
    this.fullName = value
  }
  // 塾名をセット
  private setAcademyName(value: string) {
    this.academyName = value
  }
  // 教室名をセット
  private setBranchName(value: string) {
    this.branchName = value
  }
  // ステータスをセット
  private setStatus(value: string) {
    this.status = value
  }
  // 全チェックフラグをセット
  private setCheckedAll(value: boolean) {
    this.checkedAll = value
  }
  // チェックされた生徒ユーザーIDをセット
  private setCheckedStudentUserIds(value: number[]) {
    this.checkedStudentUserIds = value
  }

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: keyof StudentListSortType) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }

  // 新規登録モーダルを開く
  private async openRegisterModal() {
    if (!this.setRegisterDataEvent) {
      return
    }

    await this.setRegisterDataEvent()
    if (this.studentEditData) {
      this.modalStudentEdit.show()
    }
  }

  // 編集モーダルを開く
  private async openEditModal(id: number) {
    await this.setEditDataEvent(id)
    if (this.studentEditData) {
      this.modalStudentEdit.show()
    }
  }

  // 見出しタブリンクの表示設定
  private get tabSetting(): TeacherStudentTabSetting {
    return TeacherStudentTabSetting
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // 教室長であるか
  private get isBranch(): boolean {
    return this.userRole === UserRoles.BRANCH
  }
}
</script>

<style lang="stylus" scoped>
.student-list
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

        &__tab
          &:nth-child(1)
            border-bottom-left-radius 12px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__action
          display flex
          justify-content space-between
          align-items center
          padding 12px 20px

          &__search
            padding 7px 5px

          &__button
            display flex
            gap 12px

            &__icon
              width 32px
              height 32px

        &__footer
          display flex
          justify-content flex-end
          align-items center
          padding 20px 30px
          margin-top auto

  &[data-role='branch'] &__content
    &__body
      &__heading
        &__tab
          border-bottom-left-radius unset

      &__main
        border-radius 0 15px 15px 15px
</style>
